const otpIdentityVerificationTemplate = `
<pwr-otp-identity-verification-component 
    options="ctrl.options"
    is-ots-user="isOtsUser"
></pwr-otp-identity-verification-component>
`;
export default otpIdentityVerificationTemplate;
